import React, { useEffect } from "react";
import { useLocation } from 'react-router-dom';
import { useTranslation } from "react-i18next";

// component
import Header from 'components/layout/header';
import Footer from 'components/layout/footer';
import Helmet from 'components/helmet/helmet';

const Layout = ({children}) => {
	const { t } = useTranslation();
	const location = useLocation();

	useEffect(() => {
		window.scrollTo(0, 0);
	}, [location.pathname])

	return (
		<>
			<Helmet>
				<title>{t('common_ihic')}</title>
				<meta name="description" content="館時間のお願い (2020/09/18) ツアー形式のために、予約時間に遅れることなく多くの方がご来館くださいます。ありがとうございます。 入館時間につき、ご留意お願い申し上げます。 1回目： 09:55から入館可能 2回目： 12:15から入館可能 3回目： 14:45から入館可能 開館準備や、他のツアーグループが退館するまで、ご入館いただけない場合があります。 *** オンライン予約システムのお知らせ（2020/09/01) 当センターへのご関心ありがとうございます。 来館には、事前予約が必要です。 予約は https://booking.ihic.jp/ です。 または、こちらをクリックしてください。 [留意] 観覧は『ガイド付きの時間限定のツアー』のみです。 開始時間に全員揃わないと他の来館者の迷惑になります。 *** 情報センターへのアクセスのお知らせ（2020/8/27) 当センターへは、「公共交通機関またはタクシー」をご利用ください。 自転車および二輪車を含む自家用車では、別館および総務省敷地内には 乗り入れできません。その場合は、近辺の有料駐車場をご利用ください。 ＊＊＊ 予約およびガイド案内のお知らせ（2020/8/17) 現在当館では事前予約制を実施しています。 １．３枠ともに、見学時間は２時間です。 ２．現在は、ガイド付きツアー形式です。 予約枠ごとにガイドがアテンドします。 ＊＊＊ 一般の来館者の方々にはご了承お願い申し上げますが メディア取材と同じ時間帯になる場合があります。 改めてご理解いただけますようお願い申し上げます。 ＊＊＊＊＊＊ 産業遺産情報センターについて 産業遺産情報センターは、世界遺産「明治日本の産業革命遺産 製鉄・製鋼、造船、石炭産業」の インタープリテーション戦略（２０１７年１１月 ユネスコ世界遺産センターに提出）に基づき 「明治日本の産業革命遺産」の８県１１市に立地するビジターセンターの中核センターとして 各地と連携しインタープリテーション戦略を推進します。 なお、同センターは調査研究機関としての機能を有し、国内外の産業遺産並びに産業史の史料収集、 調査研究、広報活動、インタープリテーション、教育・研修、保全と活用、 ディジタル文書化などの事業を推進し、情報発信を行います。 調査・研究には産業労働や暮らしについての調査や発信が含まれます。 ２０２０年３月３１日に開設されましたが、新型コロナウイルスの感染拡大を防止するため 臨時休館しておりました。 緊急事態宣言の解除および東京都の活動再開のロードマップを踏まえ ２０２０年６月１５日より公開いたします。 新型コロナウイルスの感染拡大防止のための対策の一つとして 入場人数を制限し、当面、完全予約制といたします。 ＊＊＊"/>
			</Helmet>
			<Header />
			<main className="l-content">
				{ children }
			</main>
			<Footer />
		</>
	);
};


export default Layout;